export default __webpack_public_path__ + "static/media/gallery_07.56f87815.jpg";